import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComercialInterfaceHeader from "../../../../../components/comercial/ComercialInterfaceHeader";
import DynamicPriceInput from "../DynamicPriceInput";
import { sharedStyles } from "../../../../../styles/shared";

const WEEKDAY_KEYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const DynamicPriceForm = ({ dynamicPriceAllowed, pricesAreValid, submittedOnce, dynamicPrices, setDynamicPrices }: any) => {
    const { t } = useTranslation();

    if (!dynamicPriceAllowed) return null;

    const handlePriceChange = (index: number, value: number | null) => {
        const updatedPrices = [...dynamicPrices];
        updatedPrices[index] = value;
        setDynamicPrices(updatedPrices);
    };

    return (
        <>
            <ComercialInterfaceHeader title={t("servicePage.management.form.dynamicPriceTitle")} />
            <Box
                ref={(ref: any) => ref && !pricesAreValid && submittedOnce && ref.querySelector('input[aria-invalid="true"]')?.focus()}
                sx={sharedStyles.dynamicPriceInputsContainer}
            >
                {WEEKDAY_KEYS.map((key, index) => (
                    <Box key={key} sx={{ maxWidth: "150px" }}>
                        <DynamicPriceInput
                            value={dynamicPrices[index]}
                            setValue={(value) => handlePriceChange(index, value)}
                            label={t(`timeRange.days.${key}`)}
                            submittedOnce={submittedOnce}
                        />
                    </Box>
                ))}
            </Box>
        </>
    );
};